import { z } from 'zod/v4';

import { routeModifierLinkSchema } from './route-modifier-link.schema';

export const routeModifierInfoSchema = z.object({
  SetID: z.number(),
  name: z.string(),
  tag: z.string().nullable(),
  links: z.array(routeModifierLinkSchema),
});

export type RouteModifierInfo = z.infer<typeof routeModifierInfoSchema>;
